import { getNestedProperty } from './';

export const isUserOnlyParent = (user) => {
  return Boolean(
    getNestedProperty('isParent', user) &&
      !getNestedProperty('isAthlete', user),
  );
};
